const {
    UPDATE,
    DRAFT_STORE_DETAILS,
    DRAFT_ZIP_CODE,
    CLEAR_UPPER_FUNNEL_DRAFT,
    UPDATE_SMS_STATUS,
    TOGGLE_SELECT_AS_DEFAULT_PAYMENT
} = require('constants/actionTypes/user');

const initialState = {
    profileStatus: 0,
    profileLocale: '',
    isInitialized: false,
    selectedAsDefaultPaymentName: ''
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case UPDATE:
            return Object.assign({}, state, action.data);
        case DRAFT_STORE_DETAILS: {
            const { preferredStoreInfo } = state;
            const nextState = {
                ...state,
                preferredStoreInfo: {
                    ...preferredStoreInfo,
                    draft: {
                        ...action.payload
                    }
                }
            };

            return nextState;
        }
        case UPDATE_SMS_STATUS: {
            const nextState = {
                ...state,
                smsStatus: action.payload
            };

            return nextState;
        }
        case CLEAR_UPPER_FUNNEL_DRAFT: {
            const { preferredStoreInfo } = state;
            const nextState = {
                ...state,
                draft: {},
                preferredStoreInfo: {
                    ...preferredStoreInfo,
                    draft: {}
                }
            };

            return nextState;
        }
        case DRAFT_ZIP_CODE: {
            const nextState = {
                ...state,
                draft: { preferredZipCode: action.payload }
            };

            return nextState;
        }
        case TOGGLE_SELECT_AS_DEFAULT_PAYMENT:
            return {
                ...state,
                selectedAsDefaultPaymentName: action.payload.paymentName === state.selectedAsDefaultPaymentName ? '' : action.payload.paymentName
            };
        default:
            return state;
    }
};

module.exports = reducer;
